import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AppService } from '@core/services/app.service';

/**
 * Interceptor để tự động quản lý thanh tiến trình (Loading Bar) trên toàn cục.
 * Mỗi khi có một yêu cầu HTTP được thực hiện, nó sẽ thông báo cho AppService để hiển thị loading.
 */
@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private appService: AppService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Bật thanh tiến trình khi request bắt đầu
    this.appService.showLoading();

    return next.handle(req).pipe(
      finalize(() => {
        // Tắt thanh tiến trình khi request kết thúc hoặc lỗi
        this.appService.hideLoading();
      })
    );
  }
}
